'use client';

import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { ChevronDown } from '@/app/components/icons/ChevronDown';
import { API_URL } from '@/app/constants';
import { cn } from '@/app/utils';
import { BODY, SECTION_HEADING, SUBHEAD } from '../../_constants/s/typography';

const FAQ_KEYS = ['q1', 'q2', 'q3', 'q4', 'q5', 'q6', 'q7'] as const;

const FAQ_LINK_CLASS = 'text-[#0086FF] underline underline-offset-2 hover:text-[#3aa0ff]';

export function QuestionSection() {
  const t = useTranslations('vidu-s');
  const [openIndex, setOpenIndex] = useState(0);
  const docUrl = `${API_URL}/vidu-stream/doc`;

  return (
    <section className="relative w-full bg-transparent px-8 pt-20 pb-40 text-[#121826] sm:px-4 sm:pt-12 sm:pb-24">
      <div className="mx-auto flex w-full max-w-[900px] flex-col">
        <h2
          data-reveal
          className={SECTION_HEADING}
          // biome-ignore lint/security/noDangerouslySetInnerHtml: controlled i18n HTML fragment
          dangerouslySetInnerHTML={{ __html: t.raw('faq.title') as string }}
        />

        <div className="divide-y divide-[#121826]/10 border-[#121826]/10 border-y">
          {FAQ_KEYS.map((key, index) => {
            const isOpen = openIndex === index;
            return (
              <div key={key} data-reveal data-reveal-delay={String(Math.min(index, 5))}>
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? -1 : index)}
                  className="flex w-full cursor-pointer items-center justify-between gap-6 px-2 py-[30px] text-left sm:py-5"
                >
                  <span className={cn('flex-1 font-medium', SUBHEAD)}>{t(`faq.${key}.title`)}</span>
                  <ChevronDown
                    className={cn(
                      'size-4 shrink-0 text-[#121826] transition-transform duration-300',
                      isOpen && 'rotate-180',
                    )}
                  />
                </button>
                <div
                  className="grid transition-[grid-template-rows] duration-300 ease-[cubic-bezier(.33,1,.68,1)]"
                  style={{ gridTemplateRows: isOpen ? '1fr' : '0fr' }}
                >
                  <div className="overflow-hidden">
                    <p className={cn('whitespace-pre-line px-2 pb-8 text-[#121826]/60 sm:pb-5', BODY)}>
                      {key === 'q7'
                        ? t.rich('faq.q7.description', {
                            docUrl,
                            link: (chunks) => (
                              <a href={docUrl} target="_blank" rel="noopener noreferrer" className={FAQ_LINK_CLASS}>
                                {chunks}
                              </a>
                            ),
                          })
                        : t(`faq.${key}.description`)}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
